import { PurposeData } from '../../../../shared/types'

export const filter = function (array: string[]) {
  return function ({ id }: PurposeData) {
    return array.includes(id)
  }
}
